import NumberFlow, {continuous} from "@number-flow/react";
import {CaretRightIcon, ClockCountdownIcon, WarningCircleIcon} from "@phosphor-icons/react";
import {ArrowUpRightIcon, ArrowDownRightIcon} from "@phosphor-icons/react/dist/ssr";
import {useData} from "context/data.context";
import {CURRENCY_LONG, LOCALE, CLASS_LABELS} from "utilities/global.variables";
import {formatCurrency, formatPercent} from "utilities/global.functions";

const TotalCard = ({isAsset, isLiability, onClick}) => {
  const { networthCurrent } = useData();

  // — Data initialisation —
  let total = 0,
    count = 0,
    classes = [],
    heading = "",
    type = "",
    change = 0,
    percent = 0,
    updates = 0,
    arrow = null,
    classCounts = [],
    sign = "";

  if (isAsset) {
    heading = "Total Assets";
    type = "asset";
    total = networthCurrent.assets.total ?? 0;
    count = networthCurrent.assets.count ?? 0;
    change = networthCurrent.assets.ytd ?? 0;
    percent = networthCurrent.assets.ytdPercent ?? 0;
    updates = networthCurrent.assets.needs_update ?? 0;
    arrow = change >= 0 ? <ArrowUpRightIcon size={10} /> : <ArrowDownRightIcon size={10} />;
    classes = networthCurrent.assets.classes;
    sign = change > 0 && "+"
  }

  if (isLiability) {
    heading = "Total Liabilities";
    type = "liability";
    total = networthCurrent.liabilities.total ?? 0;
    count = networthCurrent.liabilities.count ?? 0;
    change = networthCurrent.liabilities.ytd ?? 0;
    percent = networthCurrent.liabilities.ytdPercent ?? 0;
    updates = networthCurrent.liabilities.needs_update ?? 0;
    arrow = change >= 0 ? <ArrowUpRightIcon size={10} /> : <ArrowDownRightIcon size={10} />;
    classes = networthCurrent.liabilities.classes;
    sign = change < 0 && "-"
    change = change < 0 && Math.abs(change)
  }



  // — Derived —
  const labels = CLASS_LABELS;
   classCounts = Object.entries(labels)
    .map(([key, label]) => {
      const cls = classes.find((c) => c.name === key);
      if (!cls || cls.count === 0) return null;
      return <p key={key} className="flag small ">{label} {cls.count}</p>;
    })
    .filter(Boolean);



  return (
    <>
      <div className="Total">
        <div className="card  flex col space xxlarge-gap">
          <div className="flex row space  ">
            <div className="flex row large-gap center ">
              <div><p className="large"> {heading}</p></div>
         
            </div>

            <div className="flex row center small-gap">
                   <div className=" ">
                <p className="regular">{updates} / {count} </p>
              </div>
              <ClockCountdownIcon size={16} />
            </div>
          </div>

          <div className="flex col small-gap ">
            <NumberFlow className="number xxxlarge" plugins={[continuous]} locales={LOCALE} format={CURRENCY_LONG} value={total} />

            <div className="flex row center medium-gap">
              <div className={"flex row center small-gap flag  " + type}>
                {arrow}
                <p className="regular"> {formatPercent(percent)}</p>
              </div>
              <p className="medium o90">{sign} {formatCurrency(change)} this year</p>
            </div>
          </div>

          <div className="flex row medium-gap">{classCounts}</div>
        </div>
      </div>
    </>
  );
};
export default TotalCard;
